import VideoPlayer from './video_player';

export default VideoPlayer;
